import React from "react";
import {
  MoveRight,
  Leaf,
  BarChart3,
  Target,
  Eye,
  Calculator,
} from "lucide-react";

// Image
import about from "assets/images/malyarpic.png";
import FeatureCards from "./FeatureCards";

const AboutUs = () => {
  return (
    <React.Fragment>
      <style>
        {`
          .gradient-text {
            background: linear-gradient(135deg, #4CAF50 0%, #2E7D32 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }
          
          .feature-card {
            transition: all 0.3s ease;
            border-radius: 16px;
            background: rgba(255, 255, 255, 0.8);
            backdrop-filter: blur(10px);
            border: 1px solid rgba(255, 255, 255, 0.5);
            box-shadow: 0 8px 32px rgba(31, 38, 135, 0.1);
          }
          
          .feature-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 12px 40px rgba(31, 38, 135, 0.2);
          }
          
          .image-border-effect {
            position: relative;
            border-radius: 16px;
            overflow: hidden;
          }
          
          .image-border-effect::before {
            content: '';
            position: absolute;
            inset: -5px;
            border-radius: 20px;
            padding: 2px;
            background: linear-gradient(45deg, #4CAF50, #2E7D32, #8BC34A, #4CAF50);
            -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
            -webkit-mask-composite: xor;
            mask-composite: exclude;
            animation: borderRotate 8s linear infinite;
          }
          
          @keyframes borderRotate {
            0% { background-position: 0% 0%; }
            100% { background-position: 200% 200%; }
          }
          
          .floating {
            animation: float 6s ease-in-out infinite;
          }
          
          @keyframes float {
            0% { transform: translateY(0px); }
            50% { transform: translateY(-15px); }
            100% { transform: translateY(0px); }
          }
        `}
      </style>

      <section
        className="relative bg-gradient-to-b md:px-20 px-0 from-[#F4F7FA] to-[#E8F5E9] py-10 rtl text-right overflow-hidden"
        id="product"
      >
        {/* Decorative elements */}
        <div className="absolute top-0 left-0 w-72 h-72 bg-green-400/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-green-500/10 rounded-full blur-3xl"></div>

        <div className="container 2xl:max-w-[87.5rem] px-4 mx-auto relative z-10">
          {/* Section header */}
          <div className="text-center mb-16" data-aos="fade-down">
            <h2 className="text-1xl md:text-4xl font-bold text-gray-800 mb-4">
              درباره <span className="gradient-text">هاویر کشت</span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-green-500 to-green-700 mx-auto rounded-full"></div>
          </div>

          <div className="grid items-center grid-cols-1 gap-12 lg:grid-cols-12">
            {/* عکس - سمت چپ */}
            <div className="lg:col-span-5">
              <div className="relative" data-aos="zoom-out-up">
                <div className="image-border-effect floating">
                  <img
                    src={about}
                    alt="درباره محصول"
                    className="w-full h-auto rounded-2xl shadow-2xl"
                  />
                </div>

                {/* Decorative elements */}
                <div className="absolute -top-6 -right-6 w-28 h-28 bg-green-300/20 rounded-full z-0"></div>
                <div className="absolute -bottom-6 -left-6 w-20 h-20 bg-green-400/30 rounded-full z-0"></div>

                {/* Floating icon */}
                <div
                  className="absolute -top-4 -left-4 bg-white p-3 rounded-full shadow-lg"
                  data-aos="fade-down"
                  data-aos-delay="800"
                >
                  <Leaf size={24} className="text-green-600" />
                </div>
              </div>
            </div>

            {/* متن - سمت راست */}
            <div className="lg:col-span-7">
              <div
                className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-xl border border-white/20"
                data-aos="fade-left"
              >
                <p
                  className="mb-8 text-lg text-slate-600 leading-loose rtl text-right"
                  data-aos="fade-right"
                  data-aos-delay="300"
                >
                  هاویر کشت سامانه‌ای مبتنی بر آخرین فناوری‌های روز است که به
                  پیمانکاران و کشاورزان کشت چغندر قند در جهت رصد و پایش محصولات
                  و صورتحساب‌های مالی خود کمک می‌کند. سامانه هاویر کشت به‌صورت
                  لحظه‌ای و آنلاین آخرین تغییرات را به اطلاع کشاورزان می‌رساند و
                  شفافیت لازم در صورت‌حساب‌های آن‌ها ایجاد می‌کند. این سامانه
                  وزن بار، عیار، درصد افت، قیمت تمام‌شده، سهمیه قند و تفاله، بذر
                  دریافتی و دیگر اقلام هر کشاورز را به‌صورت شفاف در دسترس آن‌ها
                  قرار می‌دهد.
                </p>

                <FeatureCards />
              </div>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default AboutUs;
